<template>
  <div class="container" ref="main">
    <div class="data-source">数据来源：健康评估</div>
    <div
      class="top"
      :style="{
        backgroundColor: `rgb(${$store.state.mHealthInfo.themeColor})`,
      }"
    >
      <div class="bg">
        <div class="get-more" @click="showDescription = true">
          查看更多 <i class="el-icon-arrow-right"></i>
        </div>
        <!-- <div class="get-more2"><i class="el-icon-arrow-right"></i></div> -->
        <img class="title" src="@/assets/images/h-health/ar_text.png" alt />
        <!-- <div class="description">这里的内容每月只可修改一次哦</div> -->
      </div>
    </div>
    <div class="content">
      <div class="new">
        <div class="card2 hvalue">
          <div class="card-title">
            <span
              class="icon"
              :style="{
                backgroundColor: `rgb(${$store.state.mHealthInfo.themeColor})`,
              }"
            ></span>
            <span class="name">健康指数</span>
            <span
              class="question"
              @click="topQuestion"
              :style="{
                backgroundColor: data.hvalue
                  ? `rgb(${$store.state.mHealthInfo.themeColor})`
                  : 'rgb(206, 206, 206)',
              }"
            >
              <img src="@/assets/images/h-health/h_writeQuestion.png" alt />
            </span>
          </div>
          <div class="card-body"></div>
          <p class="health-tips" v-if="!loading && !data.hvalue">
            通过完成<span>健康问卷</span>和<span>上传体检报告</span>，智能健康管家可以提供全面的<span>健康风险评估</span>，为您的健康保驾护航。
          </p>
          <circle-progress
            v-if="!loading"
            class="circleProgress"
            :progress="data.hvalue"
            :perfectValue="data.theoreticalHValue"
            ref="circleProgress"
          ></circle-progress>
          <div class="health-exam" v-if="!loading && !data.hvalue">
            <p>首次使用，需要先进行一个简单的健康问卷</p>
            <button
              :style="{
                backgroundColor: `rgb(${$store.state.mHealthInfo.themeColor})`,
              }"
              class="question-btn"
              @click="goEvaluation"
            >
              健康问卷
            </button>
            <p style="margin-top: 10px; color: #f65e3e !important">
              注：测评结束返回至该页面可上传体检报告
            </p>
          </div>
          <div class="health-exam" v-if="!loading && data.hvalue">
            <button
              :style="{
                backgroundColor: `rgb(${$store.state.mHealthInfo.themeColor})`,
              }"
              class="upload-report"
              @click="goUpload"
            >
              上传/查看体检报告
            </button>
            <p class="upload-tips">上传最新体检报告可完善您的健康信息</p>
          </div>
        </div>
      </div>
      <div class="card archiveType" id="archive-item-0">
        <template>
          <!-- 三个tab内容 -->
          <div class="title2">
            <span
              v-for="(i, k) in tabList"
              :key="k"
              class="name"
              :class="{ active: k == activeTab }"
              @click="switchTab(k)"
              >{{ i.title }}</span
            >
          </div>
          <div class="no-hvalue" v-if="!data.hvalue">
            <span>暂无信息</span>
          </div>
          <div v-else>
            <!-- 基本信息tab内容OK -->
            <template v-if="activeTab == 0">
              <template v-for="(item1, index1) in baseInfo.baseDataValue">
                <div
                  class="archiveItem"
                  v-if="
                    index1 < baseInfoLength &&
                    item1.dataItemShow != '腰围（cm）' &&
                    item1.dataItemShow != 'BMI' &&
                    item1.dataItemShow != '身高（cm）' &&
                    item1.dataItemShow != '体重（kg）' &&
                    item1.dataItemShow != '血型'
                  "
                  :key="index1"
                >
                  <span class="name">{{ item1.dataItemShow }}</span>
                  <span class="value value2">{{
                    item1.baseDataValue || item1.dataItemDefault
                      ? item1.baseDataValue
                        ? item1.baseDataValue
                        : item1.dataItemDefault
                      : "未设置"
                  }}</span>
                </div>
              </template>
              <!-- <div
                class="up-down"
                :style="{ color: `rgb(${$store.state.mHealthInfo.themeColor})` }"
                @click="upDown('baseInfo')"
                v-if="baseInfo.baseDataValue && baseInfo.baseDataValue.length > 3"
              >
                {{ baseInfoLength > 3 ? "收起" : "展开" }}
                <span
                  :class="{ up: baseInfoLength > 3, down: baseInfoLength <= 3 }"
                  >></span
                >
              </div> -->
            </template>
            <!-- 体检信息tab内容OK -->
            <template v-if="activeTab == 1">
              <template v-for="(item, index) in examInfo">
                <div
                  class="card archiveType bt"
                  style="margin-top: 0"
                  v-if="index < examInfoLength"
                  :key="index"
                >
                  <template>
                    <div class="archiveItem1" style="margin: 0" :key="index">
                      <template>
                        <div class="name">
                          {{ item.title }}
                        </div>
                        <template>
                          <template>
                            <template v-for="(item2, index2) in item.list">
                              <div class="subItem" :key="index2">
                                <span class="subName">{{
                                  item2.baseDataItemNameShow
                                }}</span>
                                <span class="subValue"
                                  >{{ item2.baseDataValue
                                  }}{{ item2.unit }}</span
                                >
                              </div>
                            </template>
                          </template>
                        </template>
                      </template>
                    </div>
                  </template>
                </div>
              </template>
              <div
                class="up-down"
                :style="{
                  color: `rgb(${$store.state.mHealthInfo.themeColor})`,
                }"
                @click="upDown('examInfo')"
                v-if="examInfo && examInfo.length > 3"
              >
                {{ examInfoLength > 3 ? "收起" : "展开" }}
                <span
                  :class="{
                    up: examInfoLength > 3,
                    down: examInfoLength <= 3,
                  }"
                  >></span
                >
              </div>
            </template>
            <!-- 服务使用记录tab内容 -->
            <template v-if="activeTab == 2 && order.orderTotalCount > 0">
              <div class="archiveItem">
                <span class="name">核保体检服务数</span>
                <span class="value value2">{{ order.examBookingCount }}</span>
              </div>
              <div class="archiveItem">
                <span class="name">电话医生服务数</span>
                <span class="value value2">{{ order.callDoctorCount }}</span>
              </div>
              <div class="archiveItem">
                <span class="name">视频医生服务数</span>
                <span class="value value2">{{ order.videoDoctorCount }}</span>
              </div>
              <div class="archiveItem" v-if="orderLength > 3">
                <span class="name">专家预约服务数</span>
                <span class="value value2">{{
                  order.expertAppointmentCount
                }}</span>
              </div>
              <div class="archiveItem" v-if="orderLength > 3">
                <span class="name">专家手术服务数</span>
                <span class="value value2">{{ order.expertSurgeryCount }}</span>
              </div>
              <div class="archiveItem" v-if="orderLength > 3">
                <span class="name">专家病房服务数</span>
                <span class="value value2">{{ order.expertWardCount }}</span>
              </div>
              <div class="archiveItem" v-if="orderLength > 3">
                <span class="name">健康体检服务数</span>
                <span class="value value2">{{ order.medicalCount }}</span>
              </div>
              <div
                class="up-down"
                :style="{
                  color: `rgb(${$store.state.mHealthInfo.themeColor})`,
                }"
                @click="upDown('order')"
                v-if="orderLength >= 3"
              >
                {{ orderLength > 3 ? "收起" : "展开" }}
                <span
                  :class="{
                    up: orderLength > 3,
                    down: orderLength <= 3,
                  }"
                  >></span
                >
              </div>
            </template>

            <template v-if="activeTab == 2 && order.orderTotalCount == 0">
              <div class="no-hvalue">暂无记录</div>
            </template>
          </div>
        </template>
      </div>
      <!-- 体检信息附加内容 -->
      <div class="temp-div" v-if="activeTab == 1 && data.hvalue">
        <div class="order-list" v-for="(o, oi) in examList" :key="oi">
          <div class="order-date">
            <div class="order-circle">
              <span></span>{{ getYMD(o.createTime) }}
            </div>
            <div class="order-no2">
              <dl>
                <dd>
                  检查机构：<span>{{ getReportSource(o) }}</span>
                </dd>
              </dl>
            </div>
          </div>
        </div>
      </div>
      <!-- 服务使用记录附加内容 -->
      <div class="temp-div" v-if="activeTab == 2 && data.hvalue">
        <div class="order-list" v-for="(o, oi) in order.orderList" :key="oi">
          <div class="order-date">
            <div class="order-circle"><span></span>{{ o.updateTime }}</div>
            <div class="order-no">
              <dl>
                <dt>
                  订单号：{{ o.orderNo }}
                  <span :style="{ color: getState(o).colorStr }">{{
                    getState(o).stateStr
                  }}</span>
                </dt>
                <dd>
                  服务名称：<span>{{ o.productName }}</span>
                </dd>
                <dd>
                  服务分类：<span>{{ o.productType }}</span>
                </dd>
              </dl>
            </div>
          </div>
        </div>
      </div>
      <!-- 基本信息 - 健康信息 -->
      <div class="card archiveType">
        <div
          v-if="activeTab == 0"
          class="title"
          :style="{
            'background-image': `linear-gradient(225deg, ${`rgba(${$store.state.mHealthInfo.themeColor},0.15)`}  0%, ${`rgba(${$store.state.mHealthInfo.themeColor},0.01)`} 100%)`,
          }"
        >
          <span
            class="name"
            :style="{
              color: `rgb(${$store.state.mHealthInfo.themeColor})`,
            }"
            >{{ healthData.baseDataType }}</span
          >
          <span class="prompt">{{ healthData.subTitle }}</span>
          <img class="head" src="@/assets/images/h-health/head.png" alt />
        </div>
        <template v-if="activeTab == 0 && data.hvalue">
          <template v-for="(item1, index1) in healthData.baseDataValue">
            <div
              class="archiveItem1"
              :key="index1"
              v-if="index1 < healthDataLength"
            >
              <div class="name">
                {{ item1.dataItemShow }}
              </div>
              <div v-for="(o, k) in item1.dataSubitemShow" :key="k">
                <div class="subItem">
                  <span class="subName">{{ o.dataItemShow }}</span>
                  <span class="subValue">{{
                    o.baseDataValue || o.dataItemDefault
                      ? o.baseDataValue
                        ? o.baseDataValue
                        : o.dataItemDefault
                      : "未设置"
                  }}</span>
                </div>
              </div>
            </div>
          </template>
          <!-- <div
            class="up-down"
            :style="{ color: `rgb(${$store.state.mHealthInfo.themeColor})` }"
            @click="upDown('healthData')"
            v-if="
              healthData.baseDataValue && healthData.baseDataValue.length > 3
            "
          >
            {{ healthDataLength > 3 ? "收起" : "展开" }}
            <span
              :class="{ up: healthDataLength > 3, down: healthDataLength <= 3 }"
              >></span
            >
          </div> -->
        </template>
        <div class="no-hvalue" v-if="activeTab == 0 && !data.hvalue">
          暂无数据
        </div>
      </div>

      <!-- 基本信息  -  生活方式 ok -->
      <div class="card archiveType">
        <div
          v-if="activeTab == 0"
          class="title"
          :style="{
            'background-image': `linear-gradient(225deg, ${`rgba(${$store.state.mHealthInfo.themeColor},0.15)`}  0%, ${`rgba(${$store.state.mHealthInfo.themeColor},0.01)`} 100%)`,
          }"
        >
          <span
            class="name"
            :style="{
              color: `rgb(${$store.state.mHealthInfo.themeColor})`,
            }"
            >生活方式</span
          >
          <span class="prompt">完善你的生活方式</span>
          <img class="head" src="@/assets/images/h-health/head.png" alt />
        </div>
        <template v-if="activeTab == 0 && data.hvalue">
          <template v-for="(item, i) in lifeStyle">
            <div class="archiveItem1" :key="i" v-if="i < lifeStyleLength">
              <div class="name">{{ item.title }}</div>
              <div v-for="(o, k) in item.list" :key="k">
                <div class="subItem">
                  <span class="subName">{{ o.baseDataItemNameShow }}</span>
                  <span class="subValue">{{
                    o.baseDataValue ? o.baseDataValue + o.unit : "未设置"
                  }}</span>
                </div>
              </div>
            </div>
          </template>
          <div
            class="up-down"
            :style="{
              color: `rgb(${$store.state.mHealthInfo.themeColor})`,
            }"
            @click="upDown('lifeStyle')"
            v-if="lifeStyle && lifeStyle.length > 3 && data.hvalue"
          >
            {{ lifeStyleLength > 3 ? "收起" : "展开" }}
            <span
              :class="{
                up: lifeStyleLength > 3,
                down: lifeStyleLength <= 3,
              }"
              >></span
            >
          </div>
        </template>
        <div class="no-hvalue" v-if="activeTab == 0 && !data.hvalue">
          暂无数据
        </div>
      </div>
      <div
        class="go-evaluation"
        v-if="showDays && activeTab == 0"
        :style="{
          color: `rgb(${$store.state.mHealthInfo.themeColor})`,
        }"
      >
        <p v-if="lastHValueDays > 30">距离上次测评已经{{ lastHValueDays }}天</p>
        <p v-if="lastHValueDays < 0">距离上次测评已经超过180天</p>
        <span
          @click="goEvaluation()"
          :style="{
            'border-bottom': `solid 1px rgb(${$store.state.themeColor})`,
          }"
          >去评测完善健康档案</span
        >
      </div>
    </div>
    <van-overlay
      :show="showDescription"
      @click="showDescription = false"
    ></van-overlay>
    <div class="wrapper" v-show="showDescription">
      <div class="pic-wrap">
        <img
          src="@/assets/images/h-health/close-icon.png"
          class="close-icon-h"
          @click="showDescription = false"
        />
        <img class="w-desc" src="@/assets/images/h-health/health-d.png" />
      </div>
    </div>
  </div>
</template>

<script>
const date = new Date();
const years = [];
const bigMonth = [1, 3, 5, 7, 8, 10, 12];
const months = [];
const days = []; //31天
const days2 = []; //30天
const days3 = []; //29天
const days4 = []; //28天
const heightValues = [];
const weightValues = [];
const waistlineValues = [];
const floatValues = [];
const sleepValues = [];
const lifeValues = [
  "对生活完全满意",
  "对生活大部分满意",
  "对生活部分满意",
  "对生活不满意",
];
const drinkValues = ["经常饮酒", "偶尔饮酒", "不饮酒"];
const bHepatitisValues = ["阴性", "阳性"];
const regularFoodValues = [
  "熏制、腌制类",
  "油炸食品",
  "甜点",
  "零食、加工食品（适量坚果除外）",
  "热烫食物",
  "肥肉",
  "以上均不常吃",
];
const longFoodValues = ["常食用霉变食物", "不食用霉变食物"];
const diseaseValues = ["是", "否"];
const smokeStatuValues = ["吸烟", "不吸烟", "被动吸烟", "已戒烟"];
const smokeTypeValues = ["机制卷烟", "手卷卷烟", "烟斗烟", "电子烟", "雪茄"];
const smokeDayValues = [];
const smokeStartAgeValues = [];
const smokeYearValues = [];
const eatFruitValues = [];
const drinkDayValues = [];
const sportTimeValues = [];
const highBpValues = [];
const lowBpValues = [];
const bloodSugarValues = [];
const cholesterolValues = [];
const cholesterolFloatValues = [];
const triglycerideValues = [];

// 血清甘油三酯测定
for (let i = 0; i <= 6; i++) {
  triglycerideValues.push(i);
}
// 血清总胆固醇测定
for (let i = 2; i <= 10; i++) {
  cholesterolValues.push(i);
}
// 血清总胆固醇测定 小数部分
for (let i = 0; i <= 99; i++) {
  if (i < 10) {
    cholesterolFloatValues.push("0" + i);
  } else {
    cholesterolFloatValues.push(i);
  }
}
// 血清葡萄糖测定
for (let i = 1; i <= 33; i++) {
  bloodSugarValues.push(i);
}
// 收缩压
for (let i = 0; i <= 200; i++) {
  highBpValues.push(i);
}
// 舒张压
for (let i = 0; i <= 200; i++) {
  lowBpValues.push(i);
}
// 每日运动时间
for (let i = 0; i <= 10; i++) {
  sportTimeValues.push(i * 30);
}
// 日饮酒量
for (let i = 1; i <= 20; i++) {
  drinkDayValues.push(i);
}
// 每日蔬果摄入量（克/每天）
for (let i = 0; i <= 60; i++) {
  eatFruitValues.push(i * 50);
}
// 日吸烟量
for (let i = 1; i <= 100; i++) {
  smokeDayValues.push(i);
}
// 开始吸烟年龄
for (let i = 10; i <= 100; i++) {
  smokeStartAgeValues.push(i);
}
// 烟龄
for (let i = 1; i <= 100; i++) {
  smokeYearValues.push(i);
}
//小数从0 - 7
for (let i = 0; i < 8; i++) {
  sleepValues.push(i);
}
//小数从0 - 9
for (let i = 0; i < 10; i++) {
  floatValues.push(i);
}
//年从1900 - 今年
for (let i = 1920; i <= date.getFullYear(); i++) {
  years.push(i);
}
//月从1 - 12
for (let i = 1; i <= 12; i++) {
  months.push(i);
}
//日有四种 31天、30天、29天、28天
for (let i = 1; i <= 31; i++) {
  days.push(i);
  i <= 30 ? days2.push(i) : null;
  i <= 29 ? days3.push(i) : null;
  i <= 28 ? days4.push(i) : null;
}
//身高从140cm - 250cm
for (let i = 100; i <= 230; i++) {
  heightValues.push(i);
}
//体重15kg - 200kg
for (let i = 15; i <= 200; i++) {
  weightValues.push(i);
}
//腰围15kg - 200kg
for (let i = 30; i <= 200; i++) {
  waistlineValues.push(i);
}

import circleProgress from "@/components/health/circleProgress.vue";
import {
  getArchive,
  getArchiveToB,
  getHValueDetail,
  getOrder,
  getConfig,
  getExamList,
  getLifeStyle,
  getExamInfo,
  getEvaluationState,
} from "@/config/mobile_healthApi.js";
import { mapMutations } from "vuex";
import { isEmpty, getUrlParams, getYMD } from "@/assets/js/until";
import { evaluationHost, jDomain, changcheng_qnId } from "@/config/env.js";
export default {
  name: "HealthArchive",
  data() {
    return {
      env: process.env.VUE_APP_ENV,
      loading: true, // 获取健康值loading
      showDescription: false, // 介绍弹框
      // tab1 基本信息
      baseInfo: {},
      baseInfoLength: 0,
      baseSort: [
        "姓名",
        "性别",
        "出生日期",
        "年龄",
        "国籍",
        "籍贯",
        "证件",
        "联系方式",
        "户籍地址",
        "现住址民族",
        "紧急联系人",
        "婚姻状况",
        "文化程度",
        "常住类型",
        "医疗费支付方式",
        "职业",
        "工作单位",
        "家庭年人均收入",
        "个人年收入",
      ],
      //tab1 基本信息-生活方式
      lifeStyle: [],
      lifeStyleLength: 0,
      // tab1 基本信息-健康信息
      healthData: {
        baseDataType: "健康信息",
        subTitle: "完善你的健康信息",
      },
      healthDataLength: 0,
      healthSort: [
        "家族史关系疾病",
        "疾病史名称",
        "过敏史",
        "用药史",
        "手术史组",
        "危害因素接触史",
        "外伤史",
        "输血史",
        "残疾情况",
        "体检频次",
        "生活环境",
        "月经生育史",
      ],
      // 基本信息 - 体检信息
      examInfo: [],
      examInfoLength: 0,
      // 健康信息排序规则
      mockExamInfo: {
        code: 200,
        msg: "SUCCESS.",
        data: {
          60: {
            物理检查: {
              基础检查: [
                {
                  appId: 350201,
                  baseDataItem: "身高",
                  baseDataItemCode: 600100100010,
                  baseDataItemNameShow: "身高",
                  baseDataItemValueType: "数字",
                  baseDataValue: "176.0",
                  channelName: "汇晨互动公众号",
                  createTime: 1657693198000,
                  expirationTime: 1673193600000,
                  fieldName: "",
                  hasExpire: false,
                  moduleCode: 60,
                  moduleName: "物理检查",
                  oneClassificationCode: 60010,
                  oneClassificationName: "一般检查",
                  phoneNumber: "",
                  profileId: 937230001,
                  recordDate: "2022-07-13",
                  referenceRange: "",
                  resourceId: "3502010002002",
                  resourceRemark: "3502010002002",
                  resourceType: "评测报告",
                  sourceCategory: "手动录入",
                  sourceEntrance: "健康助手问卷",
                  sourcePort: "",
                  tips: "无",
                  twoClassificationCode: 60010010,
                  twoClassificationName: "基础检查",
                  unit: "cm",
                },
                {
                  appId: 350201,
                  baseDataItem: "体重",
                  baseDataItemCode: 600100100020,
                  baseDataItemNameShow: "体重",
                  baseDataItemValueType: "数字",
                  baseDataValue: "120.0",
                  channelName: "汇晨互动公众号",
                  createTime: 1657693201000,
                  expirationTime: 1673193600000,
                  fieldName: "",
                  hasExpire: false,
                  moduleCode: 60,
                  moduleName: "物理检查",
                  oneClassificationCode: 60010,
                  oneClassificationName: "一般检查",
                  phoneNumber: "",
                  profileId: 937230001,
                  recordDate: "2022-07-13",
                  referenceRange: "",
                  resourceId: "3502010002002",
                  resourceRemark: "3502010002002",
                  resourceType: "评测报告",
                  sourceCategory: "手动录入",
                  sourceEntrance: "健康助手问卷",
                  sourcePort: "",
                  tips: "无",
                  twoClassificationCode: 60010010,
                  twoClassificationName: "基础检查",
                  unit: "Kg",
                },
                {
                  appId: 350201,
                  baseDataItem: "BMI",
                  baseDataItemCode: 600100100030,
                  baseDataItemNameShow: "BMI",
                  baseDataItemValueType: "数字",
                  baseDataValue: "38.74",
                  channelName: "汇晨互动公众号",
                  createTime: 1657693201000,
                  expirationTime: 1673193600000,
                  fieldName: "",
                  hasExpire: false,
                  moduleCode: 60,
                  moduleName: "物理检查",
                  oneClassificationCode: 60010,
                  oneClassificationName: "一般检查",
                  phoneNumber: "",
                  profileId: 937230001,
                  recordDate: "2022-07-13",
                  referenceRange: "",
                  resourceId: "3502010002002",
                  resourceRemark: "3502010002002",
                  resourceType: "评测报告",
                  sourceCategory: "手动录入",
                  sourceEntrance: "健康助手问卷",
                  sourcePort: "",
                  tips: "",
                  twoClassificationCode: 60010010,
                  twoClassificationName: "基础检查",
                  unit: "",
                },
              ],
            },
          },
        },
      },
      showEvaluationText: true,
      lastHValueDays: null,
      //服务使用记录
      order: {},
      orderLength: 3,
      //体检机构列表
      examList: [],
      activeTab: 0,
      tabList: [
        {
          title: "基本信息",
          id: 0,
        },
        {
          title: "体检信息",
          id: 1,
        },
        {
          title: "服务使用记录",
          id: 2,
        },
      ],
      data: {
        theoreticalHValue: 0,
        hvalue: 0,
      },
      showProgress: false,
      archiveData: [],
      // 输入弹窗是否可见
      // inputPopupVisible: false,
      // 输入弹窗类型
      inputPopupType: "",
      // 输入的值
      inputValue: "",

      // picker slots
      slots: [],
      editCurrentItem: null,

      showMoreIndex: 0,
      jumpIndex: 0,
      // 年龄弹窗是否可见
      agePopupVisible: false,
      ageSlots: [],
      // 性别弹窗是否可见
      sexPopupVisible: false,
      sexSlots: [],
      // 身高弹窗是否可见
      heightPopupVisible: false,
      heightSlots: [],
      // 体重弹窗是否可见
      weightPopupVisible: false,
      weightSlots: [],
      // 胸围弹窗是否可见
      waistlinePopupVisible: false,
      waistlineSlots: [],
      // 血型弹窗是否可见
      bloodTypePopupVisible: false,
      bloodTypeSlots: [],
      // 初潮年龄弹窗是否可见
      childbearing1PopupVisible: false,
      childbearing1Slots: [],
      // 初潮年龄弹窗是否可见
      childbearing2PopupVisible: false,
      childbearing2Slots: [],
      // 初潮年龄弹窗是否可见
      childbearing3PopupVisible: false,
      childbearing3Slots: [],
      // 初潮年龄弹窗是否可见
      childbearing4PopupVisible: false,
      childbearing4Slots: [],
      // 初潮年龄弹窗是否可见
      childbearing5PopupVisible: false,
      childbearing5Slots: [],
      // 初潮年龄弹窗是否可见
      childbearing6PopupVisible: false,
      childbearing6Slots: [],
      // 初潮年龄弹窗是否可见
      childbearing7PopupVisible: false,
      childbearing7Slots: [],
      // 初潮年龄弹窗是否可见
      childbearing7PopupVisible: false,
      childbearing7Slots: [],
      // 初潮年龄弹窗是否可见
      childbearing8PopupVisible: false,
      childbearing8Slots: [],
      // 初潮年龄弹窗是否可见
      childbearing9PopupVisible: false,
      childbearing9Slots: [],
      // 初潮年龄弹窗是否可见
      childbearing10PopupVisible: false,
      childbearing10Slots: [],
      // 初潮年龄弹窗是否可见
      childbearing11PopupVisible: false,
      childbearing11Slots: [],
      // childbearing1PopupVisible

      // 睡眠弹窗是否可见
      sleepPopupVisible: false,
      sleepSlots: [],
      // 蔬菜水果摄入量（每天）弹窗是否可见
      eatFruitPopupVisible: false,
      eatFruitSlots: [],
      // 肉（猪、牛、羊、禽）摄入量（每天）弹窗是否可见
      eatMeatPopupVisible: false,
      eatMeatSlots: [],
      // 是否食用久存或受潮的粮食、坚果弹窗是否可见
      longFoodPopupVisible: false,
      longFoodSlots: [],
      // 快餐依赖程度（每周）弹窗是否可见
      fastFoodPopupVisible: false,
      fastFoodSlots: [],
      // 每日运动时间弹窗是否可见
      sportTimePopupVisible: false,
      sportTimeSlots: [],
      // 生活满意度弹窗是否可见
      lifePopupVisible: false,
      lifeSlots: [],
      // 饮酒状况弹窗是否可见
      drinkPopupVisible: false,
      drinkSlots: [],
      // 日饮酒量弹窗是否可见
      drinkDayPopupVisible: false,
      drinkDaySlots: [],
      // 吸烟状况弹窗是否可见
      smokeStatuPopupVisible: false,
      smokeStatuSlots: [],
      // 吸烟种类弹窗是否可见
      smokeTypePopupVisible: false,
      smokeTypeSlots: [],
      // 日吸烟量弹窗是否可见
      smokeDayPopupVisible: false,
      smokeDaySlots: [],
      // 开始吸烟年龄弹窗是否可见
      smokeStartAgePopupVisible: false,
      smokeStartAgeSlots: [],
      // 烟龄弹窗是否可见
      smokeYearPopupVisible: false,
      smokeYearSlots: [],
      // 戒烟年限弹窗是否可见
      smokeStopPopupVisible: false,
      smokeStopSlots: [],
      // 收缩压弹窗是否可见
      highBpPopupVisible: false,
      highBpSlots: [],
      // 舒张压弹窗是否可见
      lowBpPopupVisible: false,
      lowBpSlots: [],
      // 血清葡萄糖测定弹窗是否可见
      bloodSugarPopupVisible: false,
      bloodSugarSlots: [],
      // 血清总胆固醇测定弹窗是否可见
      cholesterolPopupVisible: false,
      cholesterolSlots: [],
      // 血清甘油三酯测定弹窗是否可见
      triglyceridePopupVisible: false,
      triglycerideSlots: [],
      // 乙型肝炎表面抗原测定弹窗是否可见
      bHepatitisPopupVisible: false,
      bHepatitisSlots: [],
      // 便性状弹窗是否可见
      diseasePopupVisible: false,
      diseaseSlots: [],
      // diseasePopupVisible
      // 每周运动情况是否可见
      sportWeekPopupVisible: false,
      sportWeekSlots: [],
      // 体力活动是否可见
      sportStrengthPopupVisible: false,
      sportStrengthSlots: [],

      scroll: 0, //第一步：定义初始滚动高度
    };
  },
  created() {
    console.log(process.env.VUE_APP_ENV);
    document.title = "健康档案";
    let jumpIndex = this.$store.state.mHealthInfo.archiveJumpIndex;
    if (jumpIndex != -1) {
      this.jumpIndex = jumpIndex;
      this.showMoreIndex = this.jumpIndex;
    }
    // 取到URL带过来的参数
    let urlparams = getUrlParams(window.location.href);
    this.setUserData(urlparams);
    console.log(urlparams);
    if (!isEmpty(urlparams.appId)) {
      this.$store.commit("setAppId", urlparams.appId);
    }
    if (!isEmpty(urlparams.profileId)) {
      this.$store.commit("setProfileId", urlparams.profileId);
    }
    if (!isEmpty(urlparams.sex)) {
      this.$store.commit("setSex", urlparams.sex);
    }
  },
  mounted() {
    this.getConfig();
    this.getArchive();
    this.getHValueDetail(); //健康值
    this.getLifeStyle(); //基本信息-生活方式
    this.getExamInfo(); //体检信息
    this.getOrder(); //服务使用记录
    this.getExamList(); //体检机构列表
    this.getEvaluationState(); //是否显示基本信息底部问卷入口
    this.getYMD = getYMD;
  },
  components: {
    circleProgress,
  },
  computed: {
    // 底部问卷入口判断显示  有健康值 并且距上次评测大于30天 或 lastHValueDays<0 时距测评 >= 180天
    showDays() {
      return (
        (!this.showEvaluationText && this.lastHValueDays > 30) ||
        (!this.showEvaluationText && this.lastHValueDays < 0)
      );
    },
  },
  methods: {
    ...mapMutations(["setUserData"]),
    // 展开收起方法
    upDown(type) {
      if (type == "baseInfo") {
        //基本信息
        if (this.baseInfoLength > 3) {
          //说明是展开的
          this.baseInfoLength = 3;
        } else {
          this.baseInfoLength = this.baseInfo.baseDataValue.length;
        }
      } else if (type == "examInfo") {
        //体检信息
        if (this.examInfoLength > 3) {
          this.examInfoLength = 3;
        } else {
          this.examInfoLength = this.examInfo.length;
        }
      } else if (type == "healthData") {
        //健康信息
        if (this.healthDataLength > 3) {
          this.healthDataLength = 3;
        } else {
          this.healthDataLength = this.healthData.baseDataValue.length;
        }
      } else if (type == "lifeStyle") {
        if (this.lifeStyleLength > 3) {
          this.lifeStyleLength = 3;
        } else {
          this.lifeStyleLength = this.lifeStyle.length;
        }
      } else if (type == "order") {
        if (this.orderLength > 3) {
          this.orderLength = 3;
        } else {
          this.orderLength = 100;
        }
      }
    },
    //去完善健康档案
    goEvaluation() {
      // console.log(hMobileHost + '/mobile/home?appId='+this.$store.state.mHealthInfo.appId+'&profileId='+this.$store.state.mHealthInfo.profileId)
      // window.location.href =
      //   hMobileHost +
      //   "/mobile/home?appId=" +
      //   this.$store.state.mHealthInfo.appId +
      //   "&profileId=" +
      //   this.$store.state.mHealthInfo.profileId;
      window.location.href =
        evaluationHost +
        "/evaluation/index?appId=" +
        this.$store.state.mHealthInfo.appId +
        "&profileId=" +
        this.$store.state.mHealthInfo.profileId +
        "&qn_id=" +
        changcheng_qnId;
    },
    // 去查看体检报告列表
    goUpload() {
      // 跳转第三方页面返回刷新
      window.onpageshow = null;
      window.onpageshow = function (event) {
        location.reload();
      };
      window.location.href =
        jDomain +
        "/#/user/body-report/list?appId=" +
        this.$store.state.account.userData.appId +
        "&profileId=" +
        this.$store.state.account.userData.profileId +
        "&appKey=" +
        this.$store.state.account.userData.appKey +
        "&timestamp=" +
        this.$store.state.account.userData.timestamp +
        "&userToken=" +
        encodeURIComponent(this.$store.state.account.userData.userToken) +
        "&from=" +
        this.$store.state.account.userData.from;
    },
    //顶部查看更多
    viewMore() {
      window.location.href = "https://www.baidu.com";
    },
    //点击健康值跳转报告
    goHReport() {
      window.location.href =
        evaluationHost +
        "/evaluation/index?appId=" +
        this.$store.state.mHealthInfo.appId +
        "&profileId=" +
        this.$store.state.mHealthInfo.profileId +
        "&qn_id=" +
        changcheng_qnId;
    },
    //获取主题配置
    async getConfig() {
      const data = await getConfig({
        appId: this.$store.state.mHealthInfo.appId,
      });
      if (data.code == 200) {
        let themeColor = data.data.themeColor;
        this.$store.commit("setThemeColor", themeColor);
      }
    },
    // 基本信息-底部问卷入口
    async getEvaluationState() {
      const data = await getEvaluationState({
        profileId: this.$store.state.mHealthInfo.profileId,
      });
      if (data.code == 1) {
        let respondData = data.data;
        this.showEvaluationText = respondData.days;
        this.lastHValueDays = respondData.lastHValueDays;
      }
    },
    // 基本信息-体检信息
    async getExamInfo() {
      const data = await getExamInfo({
        profileId: this.$store.state.mHealthInfo.profileId,
        appId: this.$store.state.mHealthInfo.appId,
      });
      // const data = this.mockExamInfo;
      if (data.code == 200) {
        let respondData = data.data;

        for (let k in respondData) {
          // console.log(k);//60
          // console.log(respondData[k]);//60-data
          for (let o in respondData[k]) {
            // obj.baseDataType = o; //物理检查
            // console.log(respondData[k][o]);
            for (let i in respondData[k][o]) {
              let obj = {
                title: "",
                list: [],
              };
              obj.title = i + "(" + o + ")";
              obj.list = respondData[k][o][i];
              // console.log(i + "(" + o + ")");
              // console.log(respondData[k][o][i]);
              this.examInfo.push(obj);
            }
          }
        }
        this.examInfoLength =
          this.examInfo.length > 3 ? 3 : this.examInfo.length;
        // console.log(this.examInfo);
      }
    },
    // 基本信息-生活方式OK
    async getLifeStyle() {
      const data = await getLifeStyle({
        userId: this.$store.state.healthDocUser.userId,
        // profileId: this.$store.state.mHealthInfo.profileId,
        // appId: this.$store.state.mHealthInfo.appId,
        moduleName: "生活方式",
      });
      if (data.code == 200) {
        let respondData = data.data;
        for (let k in respondData) {
          let o = {
            title: k,
            list: respondData[k],
          };
          this.lifeStyle.push(o);
        }
        this.lifeStyleLength =
          this.lifeStyle.length > 3 ? 3 : this.lifeStyle.length;
        // console.log(this.lifeStyle);
      }
    },
    //体检机构列表
    async getExamList() {
      const data = await getExamList({
        profileId: this.$store.state.mHealthInfo.profileId,
        pageNo: 1,
        pageSize: 100,
      });
      if (data.code == 1) {
        this.examList = data.data.data;
        // console.log(this.examList)
      }
    },
    // 服务使用记录
    async getOrder() {
      const data = await getOrder({
        profileId: this.$store.state.mHealthInfo.profileId,
      });
      let data2 = {
        code: 1,
        msg: "成功",
        orderStatus: null,
        data: {
          orderTotalCount: 10,
          callDoctorCount: 0,
          videoDoctorCount: 3,
          expertAppointmentCount: 1,
          expertSurgeryCount: 2,
          expertWardCount: 4,
          medicalCount: 0,
          orderList: [
            {
              orderNo: "2022061616444799GDQG",
              productName: "长城人寿专家预约含陪诊",
              productType: "医疗服务",
              productCode: "T012991025851",
              orderType: 1,
              name: "caizhigangtest1",
              mobile: "15261231522",
              relation: 1,
              state: 1,
              updateTime: "2022-06-17 18:39:34",
            },
            {
              orderNo: "20220616181651P1M7UK",
              productName: "长城人寿专家手术",
              productType: "医疗服务",
              productCode: "T012996444189",
              orderType: 2,
              name: "caizhigangtest1",
              mobile: "15261231522",
              relation: 1,
              state: 1,
              updateTime: "2022-06-17 11:39:01",
            },
          ],
        },
      };
      if (data.code == 1) {
        this.order = data.data;
      }
    },
    async getHValueDetail() {
      const data = await getHValueDetail({
        appId: this.$store.state.mHealthInfo.appId,
        profileId: this.$store.state.mHealthInfo.profileId,
      });

      if (data.code == 200) {
        let respondData = data.data;
        this.data.hvalue = respondData.hValue;
        console.log();
        this.data.theoreticalHValue = respondData.theoreticalHValue;
        this.$store.commit("setHValue", respondData.hvalue);
        this.showProgress = true;
      }
      this.loading = false;
    },
    switchTab(index) {
      this.activeTab = index;
    },
    getReportSource(o) {
      // source	int	来源 1核保体检 2健康体检 3手动上传（该字段与下面 检查机构显示相关）
      // reportSource	string
      // 当source为1时，该字段为（ AIKANG - 爱康， MJK - 其他， KONG -”“）
      // 当source为2时，该字段不显示内容，
      // 当source为3时，显示为”手动上传“ 或不显示
      let r = "";
      if (o.source == 1) {
        if (o.reportSource == "AIKANG") {
          r = "爱康";
        } else if (o.reportSource == "MJK") {
          r = "其他";
        } else {
          r = "";
        }
      } else if (o.source >= 3) {
        r = o.reportSourceName || "";
      }

      return r;
    },
    getState(o) {
      let stateObj = {
        colorStr: "",
        stateStr: "",
      };
      // orderType是订单类型:1:专家预约 ; 2:专家病房 ; 3:专家手术 ; 4:电话医生 ;5:视频医生 ;6:健康体检
      if (o.orderType == 6) {
        //state健康体检- 0已预约 1已取消 2已到检 3已出报告 4待预约
        if (o.state == 0) {
          stateObj.colorStr = "#36CBCB";
          stateObj.stateStr = "已预约";
        } else if (o.state == 1) {
          stateObj.colorStr = "#cccccc";
          stateObj.stateStr = "已取消";
        } else if (o.state == 2) {
          stateObj.colorStr = "#FF7545";
          stateObj.stateStr = "已到检";
        } else if (o.state == 3) {
          stateObj.colorStr = "#FF7545";
          stateObj.stateStr = "已出报告";
        } else if (o.state == 4) {
          stateObj.colorStr = "#36CBCB";
          stateObj.stateStr = "待预约";
        }
      } else if (o.orderType <= 3) {
        //state三专:1申请中 2已接单 3预约中 4预约成功 5已取消 6已完成
        if (o.state == 1) {
          stateObj.colorStr = "#36CBCB";
          stateObj.stateStr = "申请中";
        } else if (o.state == 2) {
          stateObj.colorStr = "#36CBCB";
          stateObj.stateStr = "已接单";
        } else if (o.state == 3) {
          stateObj.colorStr = "#36CBCB";
          stateObj.stateStr = "预约中";
        } else if (o.state == 4) {
          stateObj.colorStr = "#FF7545";
          stateObj.stateStr = "预约成功";
        } else if (o.state == 5) {
          stateObj.colorStr = "#cccccc";
          stateObj.stateStr = "已取消";
        } else if (o.state == 6) {
          stateObj.colorStr = "#cccccc";
          stateObj.stateStr = "已完成";
        }
      } else {
        //state电话医生和视频医生不存在预约状态
        stateObj.colorStr = "";
        stateObj.stateStr = "";
      }
      return stateObj;
    },
    topQuestion() {
      this.$msgbox({
        themeColor: `rgb(${this.$store.state.mHealthInfo.themeColor})`,
        content:
          "健康指数是什么！健康指数是从您的身体、生活方式和心理维度三个方面综合评价个体健康情况的平分指数，健康指数高，代表您的身体越健康。",
        confirmText: "我知道了",
        confirm: () => {
          // 点击按钮事件
        },
      });
    },
    back() {
      this.$router.goBack();
    },
    getParams() {},
    riskAction(active) {
      this.riskActive = active;
      if (active == "uncontrollable") {
        this.riskFactorList = this.data.unControlRiskList;
      } else {
        this.riskFactorList = this.data.controlRiskList;
      }
    },
    async getArchive() {
      const data = await getArchiveToB({
        userId: this.$store.state.healthDocUser.userId,
      });
      if (data.code == 200) {
        let respondData = data.data;
        let sortData = [];
        respondData.forEach((item) => {
          if (item.baseDataType == "基本信息") {
            item.subTitle = "完善您的基本信息";
            let arr = [];
            for (let k in item.baseDataValue) {
              arr.push(item.baseDataValue[k]);
            }

            let newArr = [];
            this.baseSort.forEach((o, k) => {
              arr.forEach((a, b) => {
                if (o == a.dataItemShow) {
                  newArr.push(a);
                }
              });
            });
            item.baseDataValue = newArr;
            this.baseInfo = item;
            this.baseInfoLength = 3;
            // this.baseInfo.baseDataValue.length > 3
            //   ? 3
            //   : this.baseInfo.baseDataValue.length;
          } else if (item.baseDataType == "健康信息") {
            item.subTitle = "完善您的既往史信息";

            let arr = [];
            for (let k in item.baseDataValue) {
              arr.push(item.baseDataValue[k]);
            }

            let newArr = [];
            this.healthSort.forEach((o, k) => {
              arr.forEach((a, b) => {
                if (o == a.dataItemShow) {
                  if (o == "家族史关系疾病") {
                    a.dataItemShow = "家族史";
                  }
                  if (o == "手术史组") {
                    a.dataItemShow = "手术史";
                  }
                  if (o == "疾病史名称") {
                    a.dataItemShow = "疾病史";
                  }
                  newArr.push(a);
                }
              });
            });

            item.baseDataValue = newArr;
            this.healthData = item;
            this.healthDataLength = 3;
            // this.healthData.baseDataValue.length > 3
            //   ? 3
            //   : this.healthData.baseDataValue.length;
          }
        });
      }
    },
    getAge(strAge) {
      var birArr = strAge.split("-");
      var birYear = birArr[0];
      var birMonth = birArr[1];
      var birDay = birArr[2];

      d = new Date();
      var nowYear = d.getFullYear();
      var nowMonth = d.getMonth() + 1; //记得加1
      var nowDay = d.getDate();
      var returnAge;

      if (birArr == null) {
        return false;
      }
      var d = new Date(birYear, birMonth - 1, birDay);
      if (
        d.getFullYear() == birYear &&
        d.getMonth() + 1 == birMonth &&
        d.getDate() == birDay
      ) {
        if (nowYear == birYear) {
          returnAge = 0; //
        } else {
          var ageDiff = nowYear - birYear; //
          if (ageDiff > 0) {
            if (nowMonth == birMonth) {
              var dayDiff = nowDay - birDay; //
              if (dayDiff < 0) {
                returnAge = ageDiff - 1;
              } else {
                returnAge = ageDiff;
              }
            } else {
              var monthDiff = nowMonth - birMonth; //
              if (monthDiff < 0) {
                returnAge = ageDiff - 1;
              } else {
                returnAge = ageDiff;
              }
            }
          } else {
            return "出生日期晚于今天，数据有误"; //返回-1 表示出生日期输入错误 晚于今天
          }
        }
        return returnAge;
      } else {
        return "输入的日期格式错误！";
      }
    },
    showMore(index) {
      // //  console.log(this.showMoreIndex , index);
      if (this.showMoreIndex == index) {
        this.showMoreIndex = -1;
      } else {
        this.showMoreIndex = index;
      }
      this.$store.commit("setArchiveJumpIndex", index);
    },
  },
  beforeDestroy() {},
};
</script>

<style scoped lang="scss">
@import "@/assets/css/healthCommon.scss";
.up-down {
  text-align: center;
  font-size: 13px;
  height: 50px;
  line-height: 50px;
  .up {
    transform: rotate(-90deg) scaleY(1.5);
    display: inline-block;
  }
  .down {
    transform: rotate(90deg) scaleY(1.5);
    display: inline-block;
  }
}
/**
				 * @description: 
				 * @*params: 
				 */
.container {
  .go-evaluation {
    text-align: center;
    font-size: 14px;
    span {
      display: inline-block;
      text-decoration: underline;
    }
    p {
      color: #666666;
    }
  }
  background-color: #f5f6fa;
  position: relative;
  overflow: scroll;
  .data-source {
    height: 38px;
    line-height: 38px;
    padding-left: 40rem / $base-font;
    background-color: #fef1ef;
    font-size: 28rem / $base-font;
    color: #666;
  }
  .top {
    position: relative;
    border-radius: 0 0 20rem / $base-font 20rem / $base-font;
    .bg {
      height: 448rem / $base-font; //340
      background: url(../../../assets/images/h-health/ar_bg.png) no-repeat
        center;
      background-size: cover;
      position: relative;
    }
    .get-more {
      position: absolute;
      right: 40rem / $base-font;
      top: 90rem / $base-font;
      color: #fff;
    }
    .get-more2 {
      position: absolute;
      right: 19px;
      top: 44px;
      color: #fff;
    }

    .back {
      @include tapHighlight();
      position: absolute;
      top: 20rem / $base-font;
      left: 20rem / $base-font;
      width: 60rem / $base-font;
      height: 60rem / $base-font;
      background: url(../../../assets/images/h-health/w_back.png) no-repeat
        center;
      background-size: 70% 70%;
    }
    .title {
      width: 310rem / $base-font;
      padding-top: 70rem / $base-font;
      margin-left: 32rem / $base-font;
    }
    .description {
      opacity: 0.8;
      font-family: "PingFangSC-Regular";
      font-size: 28rem / $base-font;
      color: #ffffff;
      letter-spacing: 0.48rem / $base-font;
      line-height: 28rem / $base-font;
      margin: 16rem / $base-font 0 0 32rem / $base-font;
    }
  }
  .content {
    margin-bottom: -124rem / $base-font;
    position: relative;
    overflow: hidden;
    // z-index: 5;
    top: -288rem / $base-font;
    .new {
      // margin: 40rem / $base-font;
      margin: 40rem / $base-font;
      .card2 {
        position: relative;
        // overflow: hidden;
        // 防止滑动页面按钮隐藏
        border-radius: 12rem / $base-font;
        // margin: 32rem / $base-font 24rem / $base-font;
        background-color: #fff;
        min-height: 596rem / $base-font; // 注释查看体检报告入口前的高度
        // height: 696rem / $base-font; // 加上查看体检报告入口前的高度
      }

      .card-title {
        margin: 38rem / $base-font 0 0 36rem / $base-font;
        padding-top: 36px;
        height: 32rem / $base-font;
        position: relative;
        .icon {
          background-color: $theme-color;
          display: inline-block;
          width: 8rem / $base-font;
          height: 28rem / $base-font;
          position: absolute;
          top: 50%;
          @include translate(0, -50%);
          left: 0;
        }
        .name {
          margin-left: 0rem / $base-font;
          font-size: 32rem / $base-font;
          line-height: 32rem / $base-font;
          color: #333333;
          font-family: PingFangSC-Semibold;
          position: absolute;
          top: 50%;
          @include translate(0, -50%);
          left: 20rem / $base-font;
        }
        .question {
          img {
            width: 15rem / $base-font;
            height: 22rem / $base-font;
            position: absolute;
            top: 50%;
            left: 50%;
            @include translate(-50%, -50%);
          }
          // position: absolute;
          // top: 47rem/$base-font;
          // right: 55rem/$base-font;
          // position: relative;
          // bottom: -2rem / $base-font;
          background-color: $theme-color;
          width: 32rem / $base-font;
          height: 32rem / $base-font;
          border-radius: 16rem / $base-font;
          position: absolute;
          top: 50%;
          @include translate(0, -50%);
          left: 160rem / $base-font;
        }
      }
      .health-tips {
        width: 100%;
        padding: 0 32rem / $base-font 32rem / $base-font;
        box-sizing: border-box;
        font-size: 24rem / $base-font;
        color: #999999;
        font-family: "PingFang SC";
        font-style: normal;
        line-height: 42rem / $base-font;
        transform: translateY(100rem / $base-font);
        margin-top: -105rem / $base-font;
        margin-bottom: 42rem / $base-font;
        span {
          font-weight: 500;
          color: #333333;
          margin: 0 10rem / $base-font;
        }
      }
      .circleProgress {
        // width: 700rem/$base-font;
        height: 480rem / $base-font;
        position: relative;
        // &.no-data-c {
        //   height: 600rem / $base-font;
        // }
      }
      .health-exam {
        text-align: center;
        box-sizing: border-box;
        font-size: 24rem / $base-font;
        color: #999999;
        font-family: "PingFang SC";
        font-style: normal;
        line-height: 42rem / $base-font;
        transform: translateY(-58rem / $base-font);
        button {
          margin-top: 16rem / $base-font;
          width: 176rem / $base-font;
          height: 64rem / $base-font;
          // background: linear-gradient(97.53deg, #EA7A38 3.59%, #E4674C 100%);
          border-radius: 4px;
          color: #ffffff;
          font-size: 28rem / $base-font;
          &.upload-report {
            width: 302rem / $base-font;
          }
        }
        .upload-tips {
          margin-top: 10rem / $base-font;
        }
      }
    }
    .card {
      position: relative;
      overflow: hidden;
      border-radius: 8rem / $base-font;
      margin: 32rem / $base-font;
      background-color: #fff;
    }
    .archiveType {
      // padding: 20rem/$base-font;
      margin: 40rem / $base-font;
      .no-hvalue {
        height: 370rem / $base-font;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 28rem / $base-font;
        color: #cbcbcb;
      }
      .title2 {
        height: 124rem / $base-font;
        font-size: 30rem / $base-font;
        line-height: 124rem / $base-font;
        margin-left: 32rem / $base-font;
        .name {
          font-size: 32rem / $base-font;
          letter-spacing: 0.61rem / $base-font;
          text-align: center;
          line-height: 36rem / $base-font;
          padding-bottom: 10rem / $base-font;
          margin-right: 20rem / $base-font;
          &.active {
            font-family: "PingFangSC-Medium";
            font-weight: bold;
            border-bottom: solid 2px #f60;
          }
        }
      }
      .title {
        background-image: linear-gradient(
          225deg,
          rgba(0, 122, 255, 0.3) 0%,
          rgba(254, 255, 255, 0) 100%
        );
        height: 124rem / $base-font;
        font-size: 30rem / $base-font;
        position: relative;
        .name {
          font-family: "PingFangSC-Medium";
          font-size: 36rem / $base-font;
          color: #007aff;
          letter-spacing: 0.61rem / $base-font;
          text-align: center;
          line-height: 36rem / $base-font;

          position: absolute;
          left: 32rem / $base-font;
          top: 25rem / $base-font;
        }
        .prompt {
          font-family: "PingFangSC-Regular";
          font-size: 24rem / $base-font;
          color: #999999;
          letter-spacing: 0.41rem / $base-font;
          text-align: center;
          line-height: 24rem / $base-font;

          position: absolute;
          left: 32rem / $base-font;
          bottom: 24rem / $base-font;
        }

        .head {
          width: 156rem / $base-font;
          height: 124rem / $base-font;
          position: absolute;
          right: 0;
          top: 0;
        }
      }
      .archiveItem {
        // margin-top: 20rem/$base-font;
        margin: 0 32rem / $base-font;
        height: 80rem / $base-font;
        border-bottom: #eee solid 1rem / $base-font;
        line-height: 80rem / $base-font;
        position: relative;
        .name {
          font-family: PingFangSC-Regular;
          font-size: 28rem / $base-font;
          color: #333333;
          letter-spacing: 0.48rem / $base-font;
          // line-height: 28rem/$base-font;
        }
        .value {
          font-family: PingFangSC-Regular;
          font-size: 26rem / $base-font;
          color: #666666;
          letter-spacing: 0.44rem / $base-font;
          // line-height: 26rem/$base-font;
          position: absolute;
          top: 50%;
          @include translate(0, -50%);
          right: 59rem / $base-font;
        }
        .value2 {
          right: 0;
        }

        .arrow {
          width: 20rem / $base-font;
          height: 20rem / $base-font;
          position: absolute;
          top: 50%;
          @include translate(0, -50%);
          right: 3rem / $base-font;
        }
      }
      .archiveItem:last-child {
        border-bottom: none;
      }

      .archiveItem1 {
        // margin-top: 20rem/$base-font;
        margin: 0 32rem / $base-font;
        // height: 80rem/$base-font;
        border-bottom: #eee solid 1rem / $base-font;
        // line-height: 80rem/$base-font;
        position: relative;
        .name {
          font-family: PingFangSC-Regular;
          font-size: 28rem / $base-font;
          color: #333333;
          letter-spacing: 0.48rem / $base-font;
          margin: 24rem / $base-font 0;
        }
        .value {
          font-family: PingFangSC-Regular;
          font-size: 22rem / $base-font;
          color: #999999;
          letter-spacing: 0.38rem / $base-font;
          text-align: justify;
          margin: 24rem / $base-font 48rem / $base-font 24rem / $base-font 0;
        }

        .arrow {
          width: 20rem / $base-font;
          height: 20rem / $base-font;
          position: absolute;
          top: 50%;
          @include translate(0, -50%);
          right: 3rem / $base-font;
        }

        .arrow1 {
          width: 20rem / $base-font;
          height: 20rem / $base-font;
          position: absolute;
          top: 24rem / $base-font;
          right: 3rem / $base-font;
        }

        .subItem {
          margin-top: 24rem / $base-font;
          font-size: 22rem / $base-font;
          color: #999999;
          // height: 22rem/$base-font;
          // line-height: 22rem/$base-font;
          @include flexBox();
          .subName {
            color: #999999;
          }
          .subValue {
            @include flex_1();
            text-align: right;
            color: #666;
          }
        }
        .subItem:last-child {
          margin-bottom: 24rem / $base-font;
        }
      }

      .archiveItem1:last-child {
        border-bottom: none;
      }

      .bottom {
        text-align: center;
        height: 100rem / $base-font;
        position: relative;

        color: #007aff;
        .more {
          line-height: 26rem / $base-font;
          font-size: 26rem / $base-font;
          height: 26rem / $base-font;
          position: absolute;
          // left: 50%;
          top: 50%;
          @include translate(-50%, -50%);
          @include tapHighlight();
        }
        .arrow {
          // height: 20rem / $base-font;
          // height: 20rem / $base-font;
          // position: relative;
          // top: 3rem / $base-font;
          position: absolute;
          right: -50%;
          top: -50%;
          @include translate(-50%, -50%);

          height: 10rem / $base-font;
          line-height: 100rem / $base-font;
          font-size: 10rem / $base-font;
          display: inline-block;
          transform: scale(1.5, 0.5);
          -ms-transform: scale(1.5, 0.5); /* IE 9 */
          -moz-transform: scale(1.5, 0.5); /* Firefox */
          -webkit-transform: scale(1.5, 0.5); /* Safari and Chrome */
          -o-transform: scale(1.5, 0.5); /* Opera */
        }

        // .arrow-bottom {
        //   height: 20rem / $base-font;
        //   height: 20rem / $base-font;
        //   position: relative;
        //   top: 3rem / $base-font;

        //   display: inline-block;
        //   transform: rotate(180deg);
        //   -ms-transform: rotate(180deg); /* IE 9 */
        //   -moz-transform: rotate(180deg); /* Firefox */
        //   -webkit-transform: rotate(180deg); /* Safari and Chrome */
        //   -o-transform: rotate(180deg); /* Opera */
        // }
      }
    }
  }
}
.bt {
  border-bottom: #eee solid 1px;
}
.inputPopup {
  width: 100%;
  height: 350rem / $base-font;
  .button {
    height: 60rem / $base-font;
    .cancel {
      float: left;
      font-size: 30rem / $base-font;
      padding: 20rem / $base-font;
    }
    .confirm {
      float: right;
      font-size: 30rem / $base-font;
      padding: 20rem / $base-font;
    }
  }
  .box {
    margin-top: 20rem / $base-font;
  }
}
.temp-div {
  .order-list:nth-last-of-type(1) {
    .order-date {
      padding-bottom: 0;
    }
  }
  .order-list {
    margin: 0 40rem / $base-font 0;
    padding-left: 4px;
    .order-date {
      font-size: 14px;
      color: #999;
      border-left: 1px solid #00000024;
      position: relative;
      padding-bottom: 30px;
      .order-circle {
        padding-left: 30rem / $base-font;
        position: absolute;
        top: -10px;
        left: 0px;
        span {
          display: inline-block;
          position: absolute;
          left: -4px;
          top: 12rem / $base-font;
          border: 2px solid #ff7545;
          border-radius: 50%;
          width: 4px;
          height: 4px;
          background-color: #fff;
        }
      }
      .order-no {
        margin-left: 13px;
        padding-top: 19px;
        dl {
          background: #ffffff;
          border: 1px solid #d5d5d5;
          border-radius: 4px;
          padding-bottom: 10px;
          dt {
            position: relative;
            height: 38px;
            line-height: 38px;
            background: #f9faff;
            border-radius: 4px 4px 0px 0px;
            padding-left: 16px;
            margin-bottom: 6px;
            span {
              position: absolute;
              right: 16px;
              top: 0px;
            }
          }
          dd {
            padding-left: 16px;
            height: 26px;
            line-height: 26px;
            color: #333;
            span {
              color: #666;
            }
          }
        }
      }
      .order-no2 {
        margin-left: 13px;
        padding-top: 19px;
        dl {
          dd {
            height: 26px;
            line-height: 26px;
            color: #333;
            span {
              color: #666;
            }
          }
        }
      }
    }
  }
}
.wrapper {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 2000;
  text-align: center;
  overflow-y: scroll;
  padding: 160rem / $base-font 0 30rem / $base-font;
  .pic-wrap {
    width: 100%;

    .w-desc {
      width: 90%;
    }
    .close-icon-h {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 50rem / $base-font;
      width: 120rem / $base-font;
      height: 120rem / $base-font;
      z-index: 1000;
    }
  }
}
</style>
